<p-message
    [severity]="primeNgSeverity()"
    [closable]="closable()"
    (onClose)="onClose.emit($event)"

>
    @if (showIcon()) {
        <ng-template #icon>
            @switch (severity()) {
                @case ('success') {
                    <i class="fa fa-check"></i>
                }
                @case ('info') {
                    <i class="fa fa-info-circle"></i>
                }
                @case ('warning') {
                    <i class="fa fa-exclamation-triangle"></i>
                }
                @case ('error') {
                    <i class="fa fa-times-circle"></i>
                }
            }
        </ng-template>
    }
    <ng-template #closeicon>
        <i class="fa fa-times" [pTooltip]="closeButtonTooltip()"></i>
    </ng-template>
    <ng-content></ng-content>
</p-message>
